.dz{width:1rem;}